import { connect } from 'react-redux'
import ImageDialog from './image-dialog'
import {
  getSlide,
  getUploadImageRequest
} from '../../../../stores/presentation/presentation.selectors'
import {
  uploadImage,
  updateSlideImmediately,
  removeImageImmediately
} from '../../../../stores/presentation/presentation.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { id }) => {
  const slide = getSlide(state, id)
  const uploadImageRequest = getUploadImageRequest(state, id)
  return {
    defaultSearchValue: slide.title,
    pending: uploadImageRequest.pending,
    image: slide.image,
    offerUseCoverImage: slide.type === 'Image'
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  onUnsplashSelect: unsplashId =>
    dispatch(uploadImage(ownProps.id, { unsplash_id: unsplashId })).catch(
      errorHandler
    ),
  onFileSelect: files =>
    dispatch(uploadImage(ownProps.id, { image: files[0] })).catch(errorHandler),
  onMainImageSelect: () => {
    stateProps.image &&
      dispatch(removeImageImmediately(ownProps.id)).catch(errorHandler)
    dispatch(
      updateSlideImmediately(ownProps.id, 'Image', {
        use_presentation_image: true
      })
    )
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ImageDialog)
